import React from 'react'
import IosScreen from '../components/IosScreen'

const IosPage = () => {
  return <IosScreen />
}

export default IosPage
